module.exports = __webpack_public_path__ + "static/media/4.9c1fb020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/grodno/4.jpg
// module id = 226
// module chunks = 0